import { render, staticRenderFns } from "./AdministrationTabs.vue?vue&type=template&id=44d27224&scoped=true"
import script from "./AdministrationTabs.vue?vue&type=script&lang=ts"
export * from "./AdministrationTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d27224",
  null
  
)

export default component.exports